import { render, staticRenderFns } from "./DeleteResourceModal.vue?vue&type=template&id=0086d623&scoped=true&"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResourceModal.vue?vue&type=style&index=0&id=0086d623&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086d623",
  null
  
)

export default component.exports